export default {
  general: {
    settings: "Настройки",
    show_time: "Показывать время",
    show_seconds: "Показывать секунды",
    show_search: "Показывать строку поиска",
    show_wallpaper: "Показывать кнопку смены обоев",
    show_bookmark: "Показывать кнопку закладок",
    show_weather: "Показывать погоду",
    show_top_sites: "Показывать часто посещаемые сайты",
    auto_change_background: "Автоматически менять фон",
    auto_change_every: "Интервал смены",
    days: "дней",
    hours: "часов",
    minutes: "минут",
    interval_required: "Дни, часы и минуты не могут одновременно равняться 0",
    sync_enabled: "Облачная синхронизация задач",
    show_ai_chat: "Показывать кнопку чата с ИИ",
  },
  profile: {
    title: "Профиль",
    logout: "Выйти",
    sign_in: "Войти",
    sign_in_desc: "Пожалуйста, войдите, чтобы разблокировать полный опыт",
    avatar_updated: "Аватар успешно обновлен",
    nickname_updated: "Никнейм успешно обновлен",
    avatar_size: "Размер файла аватара не должен превышать 500 КБ",
    login_required: "Вы должны войти в систему, чтобы обновить свой аватар",
    login_success: "Вход выполнен успешно",
    user_avatar: "Аватар пользователя",
    edit_avatar: "Изменить аватар",
    save: "Сохранить",
    cancel: "Отмена"
  },
  subscription: {
    title: "Подписка",
    check: "Проверить мою подписку",
    upgrade: "Улучшить подписку",
    subscribe: "Подписаться на Tabby",
    expired_on: "Истекло: {0}",
    expires_on: "Истекает: {0}",
    plans: {
      premium: "Разблокируйте всё в Tabby — безлимитные обои, свои фоны и эксклюзивные коллекции.",
      pro: "Улучшите подписку, чтобы разблокировать безлимитные обои, свои фоны и эксклюзивные коллекции.",
      free: "Подпишитесь, чтобы разблокировать безлимитные обои, свои фоны и эксклюзивные коллекции."
    }
  },
  wallpaper: {
    title: "Обои",
    upload: "Загрузить пользовательский фон",
    upgrade_required: "Перейдите на план Pro/Premium, чтобы разблокировать функцию пользовательского фона",
    images: "Изображения",
    hues: "Оттенки",
    anims: "Анимации",
    diy: "Свой вариант",
    get_new: "Получить новый",
    upload_background: "Загрузить фон",
    add: "Добавить",
    remote_url: "URL удаленного изображения",
    size_tip: "Файлы фона меньшего размера загружают вкладки быстрее. В большинстве браузеров есть ограничение размера файла в 1,5 МБ. Для удаленных URL ограничений нет.",
    please_login: "Пожалуйста, сначала войдите",
    click_to_upload: "Нажмите для загрузки",
    video_gif_image: "видео, GIF или изображение",
    background: "фон",
    or_enter_remote_background_url: "Или введите URL удаленного фона",
    remote_url_placeholder: "https://example.com/image.jpg",
    custom_background_removed: "Пользовательский фон удален",
    failed_to_load_background: "Не удалось загрузить фон",
    using_default: "Вместо этого используется фон по умолчанию",
    insufficient_storage: "Недостаточно места для хранения",
    upload_failed: "Загрузка не удалась",
    success: "Успех",
    remote_background_added: "Удаленный фон добавлен",
    detecting_media_type: "Определение типа медиа...",
    invalid_media_type: "Нераспознанный тип медиа",
    video_load_failed: "Видео не может быть загружено, пожалуйста, проверьте правильность URL"
  },
  rewards: {
    title: "Награды",
    invite_friends: "Пригласить друзей",
    get_access: "Приглашайте друзей и получайте скидки на Pro",
    total_invites: "Всего приглашений",
    your_discount: "Ваша скидка",
    no_pro_yet: "Пока нет",
    copy_link: "Копировать ссылку-приглашение",
    copied: "Ссылка-приглашение скопирована!",
    copy_failed: "Не удалось скопировать ссылку",
    invite_description: "Друг регистрируется по вашей ссылке",
    receive_credits: "Вы получаете: 1 приглашение → −5%, 2 → −8%, 3 → −15%, 4+ → −20% · Каждый друг получает −5%"
  },
  paywall: {
    title: "Tabby Pro",
    pro_active: "PRO АКТИВЕН",
    expires: "истекает",
    free_plan: "БЕСПЛАТНЫЙ ПЛАН",
    tagline: "Разблокируйте полные лимиты чата, облачную синхронизацию задач и все функции обоев в этом расширении.",
    monthly: "ЕЖЕМЕСЯЧНО",
    yearly: "ЕЖЕГОДНО",
    month_period: "/мес",
    year_period: "/год",
    billed_monthly: "Ежемесячная оплата · отмена в любое время",
    billed_yearly: "Ежегодная оплата",
    checkout_usd: "Оплата",
    save_yearly: "Экономьте 17% по сравнению с месячным",
    best_value: "ЛУЧШАЯ ЦЕНА",
    referral_price: "Цена по приглашению",
    save: "экономия",
    subscribe_now: "Подписаться сейчас",
    current_plan: "Текущий план",
    processing: "Обработка",
    waiting_title: "Ожидание оплаты",
    waiting_desc: "Завершите оплату в открывшемся окне.",
    payment_completed: "Оплата завершена",
    having_issues: "Возникла проблема",
    invite_save: "Пригласите друзей и получайте скидку на Pro",
    sign_in_first: "Сначала войдите в систему",
    checkout_failed: "Не удалось создать сеанс оплаты",
    payment_failed: "Оплата не удалась",
    payment_wrong: "Что-то пошло не так. Пожалуйста, попробуйте еще раз.",
    success_msg: "Поздравляем! Оплата успешно завершена",
    not_paid_msg: "Оплата еще не завершена. Завершите оплату в окне или попробуйте еще раз.",
    verify_failed: "Не удалось проверить статус оплаты. Попробуйте еще раз или обратитесь в поддержку.",
    contact_email: "Свяжитесь по email: hi@tabbyio.com"
  },
  about: {
    title: "О приложении",
    version: "Версия: 1.3.11",
    contact: "Связаться с нами:",
    privacy_policy: "Политика конфиденциальности",
    terms_of_service: "Условия использования"
  },
  tabs: {
    general: "Предпочтения",
    profile: "Профиль",
    wallpaper: "Обои",
    rewards: "Награды",
    about: "О приложении"
  },
  language: {
    title: "Язык",
    en: "English",
    zh: "中文",
    de: "Deutsch",
    fr: "Français",
    pt: "Português",
    ru: "Русский",
    bn: "বাংলা",
    ja: "日本語",
    es: "Español"
  },
  buttons: {
    bookmark: "Закладки",
    next_background: "Следующий фон",
    ai_chat: "Чат с ИИ",
    search_placeholder: "Поиск или нажмите Ctrl + Enter для чата с ИИ...",
    attach: "Прикрепить файл",
  },
  top_sites: {
    title: "Часто посещаемые сайты",
    error: "Не удалось загрузить часто посещаемые сайты",
    empty: "Часто посещаемые сайты не найдены"
  },
  greetings: {
    morning: "Доброе утро",
    afternoon: "Добрый день",
    evening: "Добрый вечер",
    morning_message: "Начинается новый день, чем я могу помочь?",
    afternoon_message: "Время после полудня, есть ли вопросы, которые вы хотели бы задать?",
    evening_message: "Вечернее время, давайте поболтаем!"
  },
  intro: {
    your_portal: "Ваш портал",
    for: "для",
    productivity: "продуктивности.",
    inspiration: "вдохновения.",
    photography: "фотографии.",
    description: "Где каждая новая вкладка становится вратами",
    description_continued: "к элегантности, продуктивности и большему.",
    add_to_chrome: "Добавить в Chrome",
    free: "Бесплатно",
    try_now: "Попробовать сейчас",
    screenshot: "Скриншот"
  }
}

